import Head from "next/head";
import { api, GetAllDatoImages, convertNumberedKeysToArrays, replaceImageValues } from "../../components/helpers";
import Layout from "../../components/layouts/HomeLayout";
const productPagesContent = require("../../data/product-grk.json");
import { GoldRushPage } from "../../components/pages/GoldRushPage";

export default function GoldRushKitPage({ content, handleToast, user, busy, setMobileMenu, mobileMenuIsOpen, isTransparent, grkData }) {

    return <><Head><link
        rel="canonical"
        href={`https://www.covalenthq.com/products/goldrush/`}
        key="canonical" /></Head><Layout handleToast={handleToast} user={user} busy={busy} setMobileMenu={setMobileMenu} mobileMenuIsOpen={mobileMenuIsOpen} isTransparent={isTransparent}>
        <GoldRushPage content={content} grkData={grkData} />
    </Layout></>;

}

export async function getStaticProps() {
    const ecosystem = await api.get_all_ecosystems();
    const content = productPagesContent.filter((page) => page.slug === "goldrush")[0];
    const images = await GetAllDatoImages();
    const grkData = await api.get_all_grk();

    const transformedContent = convertNumberedKeysToArrays(replaceImageValues(content, images));
    return {
        props: {
            component: "ProductPage",
            ecosystem,
            grkData: grkData.data.allGoldrushcomponents.filter(o => o.title !== "GoldRushProvider" ),
            content: transformedContent,
        },
    };
}